import { SPECIFIC_DONATION_STATUS } from '../constants';

interface IsDonationBusinessEndedParams {
  specificDonationStatus?: string;
  dday: number;
}

//* 상태는 고향사랑e음 동기화값이라 마감일보다 늦게 ENDED로 바뀐다 — 마감일 경과도 함께 본다.
export const isDonationBusinessEnded = ({
  specificDonationStatus,
  dday,
}: IsDonationBusinessEndedParams) =>
  specificDonationStatus === SPECIFIC_DONATION_STATUS.ENDED || dday < 0;
